import { Parameter } from "domain/entities/parameter";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { MultiSelect } from "primereact/multiselect";
import React from "react";

interface ParamProps {
  fieldName: string;
  options: Parameter[];
  label: string;
  isValueId?: boolean;
  currentObject: any;
  isDisable?: boolean;
  isInvalid?: boolean;
  replaceArray?: { from: string; to: any }[];
  getValue: string | undefined | null | any;
  setValue: (updatedObject: any) => void;
}

const MultiSelectComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: DropdownChangeEvent) => {
    let selectedOption = e.value;

    // if (params.isValueId) {
    //   const currentOption = params.options.find((item) => item.id === e.value);
    //   selectedOption = currentOption ? { id: currentOption.id } : null;
    // }

    // if (params.replaceArray) {
    //   const replacement = params.replaceArray.find(
    //     (item) => item.from === e.value
    //   );
    //   if (replacement) {
    //     selectedOption = replacement.to;
    //   }
    // }

    // const updatedObject = {
    //   ...params.currentObject,
    //   [params.fieldName]: selectedOption,
    // };

    params.setValue(selectedOption);
  };

  return (
    <FloatLabel>
      <MultiSelect
        inputId={params.fieldName}
        // value={selectedCities}
        onChange={handleChange}
        options={params.options}
        optionValue={params.isValueId ? "id" : "value"}
        value={params.getValue ?? null}
        optionLabel="value"
        display="chip"
        placeholder={params.label}
        className="w-full"
        disabled={params.isDisable || false}
        invalid={params.isInvalid || false}
        filter
        filterBy="value"
        showClear
      />
      <label htmlFor={params.fieldName}>{params.label}</label>
    </FloatLabel>
  );
};

export default MultiSelectComponent;
